// extracted by mini-css-extract-plugin
export default {"msgLiberisContainer":"msgLiberisContainer___nFUea","content":"content___wBJXA","message":"message___jpuwt","msgContainer":"msgContainer___fEEvQ"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"msgLiberisContainer\":\"msgLiberisContainer___nFUea\",\"content\":\"content___wBJXA\",\"message\":\"message___jpuwt\",\"msgContainer\":\"msgContainer___fEEvQ\"}";
        // 1793018519393
        var cssReload = require("../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  